import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

// Material modules
import { MatIconModule } from '@angular/material/icon';

// Guards
import { AuthGuard } from './guards/auth.guard';
import { LoginGuard } from './guards/login.guard';

// Components
import { AuthComponent } from './components/auth/auth.component';
import { InviteComponent } from './components/invite/invite.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';



@NgModule({
  imports: [
    CommonModule,
    FormsModule,

    // Material
    MatIconModule,
  ],
  declarations: [
    AuthComponent,
    InviteComponent,
    ResetPasswordComponent,
  ],
  exports: [
    AuthComponent,
    InviteComponent,
    ResetPasswordComponent,
  ],
  providers: [
    AuthGuard,
    LoginGuard
  ],
})
export class AuthModule { }
